<template>
  <LoadingState v-if="status.isLoading" />
  <ErrorState v-else-if="status.isErrored" />
  <div v-else-if="status.isLoaded || status.isUpdating" class="row">
    <div class="col-md-4 mb-4">
      <SafeHarborThreatProtectionServices />
    </div>
    <div class="col-md-8 mb-4">
      <MagentoBlacklistTable :blacklist="blacklist" :status="status" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import MagentoBlacklistTable from "@/components/smart/tables/MagentoBlacklistTable";
import SafeHarborThreatProtectionServices from "@/components/display/cards/ThreatProtectionServices";
import store from "@/store";

export default {
  name: "SafeHarborThreatProtectionPage",
  components: {
    ErrorState,
    LoadingState,
    MagentoBlacklistTable,
    SafeHarborThreatProtectionServices,
  },
  setup() {
    const blacklist = computed(() => store.getters["safeHarbor/getSiteBlacklist"]);
    const service = computed(() => store.getters["plans/getItem"]);
    const status = computed(() => store.getters["safeHarbor/getSiteBlacklistStatus"]);

    onMounted(() => {
      store.dispatch("safeHarbor/getSiteBlacklist", service.value.cloudAccount.id);
    });

    return {
      blacklist,
      service,
      status,
    };
  },
};
</script>
